import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Center, Text, useMantineTheme } from '@mantine/core'
import React from 'react'

import { DisplayAssetProps } from '../../../../types/preview'

const CarouselView = ({
  openInModal,
  icon,
  maxWidth,
  asset,
  height,
}: DisplayAssetProps & { icon: IconDefinition }): React.ReactElement => {
  const theme = useMantineTheme()

  return (
    <Box
      sx={(theme) => ({
        height,
        backgroundColor: theme.colors[theme.primaryColor][0],
        cursor: 'pointer',
      })}
      onClick={() => openInModal()}
    >
      <Center style={{ height: '100%', flexDirection: 'column' }}>
        <FontAwesomeIcon
          icon={icon}
          style={{ color: theme.colors[theme.primaryColor][6], fontSize: 50 }}
        />

        <Box style={{ maxWidth }}>
          <Text
            size="sm"
            mt="xs"
            color={theme.primaryColor}
            px="xl"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {asset.name}
          </Text>
        </Box>
      </Center>
    </Box>
  )
}

export default CarouselView
